"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useColumnInlineDescriptionEditor = exports.ColumnInlineDescriptionEditor = void 0;
const tslib_1 = require("tslib");
const catalog_core_1 = require("@tableau/catalog-core");
const react_1 = tslib_1.__importDefault(require("react"));
const InlineDescriptionEditor_1 = require("../InlineDescriptionEditor");
function ColumnInlineDescriptionEditor(props) {
    const { element } = useColumnInlineDescriptionEditor(props);
    return element;
}
exports.ColumnInlineDescriptionEditor = ColumnInlineDescriptionEditor;
function useColumnInlineDescriptionEditor(props) {
    const { canEditDescription, columnLuid, columnTableLuid, description, afterDescriptionChange } = props;
    const { setColumnDescription } = (0, catalog_core_1.useApiRequests)();
    const onSave = react_1.default.useCallback((inputText) => tslib_1.__awaiter(this, void 0, void 0, function* () {
        const args = {
            columnLuid: columnLuid !== null && columnLuid !== void 0 ? columnLuid : '',
            tableLuid: columnTableLuid !== null && columnTableLuid !== void 0 ? columnTableLuid : '',
            description: inputText,
        };
        return yield setColumnDescription(args);
    }), [columnLuid, columnTableLuid, setColumnDescription]);
    return (0, InlineDescriptionEditor_1.useInlineDescriptionEditor)({
        canEdit: !!columnLuid && !!columnTableLuid && canEditDescription,
        onSave,
        initialDescription: description,
        afterSave: afterDescriptionChange,
        viewOnly: true,
    });
}
exports.useColumnInlineDescriptionEditor = useColumnInlineDescriptionEditor;
//# sourceMappingURL=ColumnInlineDescriptionEditor.js.map